import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NewConvoHeader from 'components/App/DesktopView/shared/NewConvoHeader'
import ReplyEmailForm from 'components/App/DesktopView/CommunicationForms/Reply/Email'
import Scroller from 'components/Scroller'
import ImageLightbox from 'components/ImageLightbox'
import { doUpsertReplyDraft } from 'ducks/drafts2/operations'
import { selectDraftIdByTicketId } from 'ducks/drafts2/selectors'
import { doFetchCurrentContact } from 'ducks/crm/contacts'
import { styles } from '../shared/styles'

export default function NewEmailPage() {
  const dispatch = useDispatch()

  const draftId = useSelector(state =>
    selectDraftIdByTicketId(state, 'new', 'reply')
  )

  useEffect(
    () => {
      dispatch(doUpsertReplyDraft(draftId, 'reply', 'new', null, {}))
      dispatch(doFetchCurrentContact())
    },
    [dispatch, draftId]
  )

  return (
    <React.Fragment>
      <NewConvoHeader isLogging={false} />
      <div css={styles.composeFormContainer}>
        <Scroller>
          <ReplyEmailForm ticketId="new" />
        </Scroller>
      </div>
      <ImageLightbox />
    </React.Fragment>
  )
}
